import { ReactNode } from 'react';
import clsx from 'clsx';
import { useProfileHeaderState } from './ProfileHeaderContext';
import style from '../ProfilePage.module.css';
import { ProfileSidebar } from './NavItems/ProfileSidebar';

type ProfileSectionProps = {
  currentProfilePage: string | null;
  is1024: boolean;
  is500: boolean;
  defaultTitle: ReactNode;
  onDefaultBack: () => void;
  children: ReactNode;
};

export const ProfileSection = ({
  currentProfilePage,
  is1024,
  is500,
  defaultTitle,
  onDefaultBack,
  children,
}: ProfileSectionProps) => {
  const header = useProfileHeaderState();

  const title = header.title ?? defaultTitle;
  const onBack = header.onBack === null
    ? undefined
    : header.onBack ?? onDefaultBack;

  return (
    <div className={style.profileSectionLayout}>
      {is1024 && <ProfileSidebar currentPage={currentProfilePage} />}

      <main className={style.profileSectionContent}>
        <div className={style.profileSectionHeader}>
          {!header.isBackButtonHidden &&
            (header.backButton ?? (
              <button
                type="button"
                onClick={onBack}
                className={clsx('button-arrowBack', style.backButton)}
              />
            ))}

          <h2 className={style.headerTitle}>
            {title}
          </h2>
        </div>

        <div className={style.profileSectionBody}>
          {children}
        </div>
      </main>
    </div>
  );
};